export default __webpack_public_path__ + "static/media/Gwalior_Fort_-Gwalior_-Madhya_Pradesh_-IMG_1315.f5c37a84.jpg";